import { defaultColDef, Column, statusRenderer, formatter } from '@qrios/frontend-library';

import locales from '../../../../constants/commonLocales';

import { renderCost } from './custom-renders/cost';
import { CostColumnHeader, CostColumnHeaderWithInfo } from './custom-headers/costColumn';

type DefaultColumnValue = (args: {
  sortable?: boolean;
  hide?: boolean;
  withInfoIcon?: boolean;
  field?: string;
  headerName?: string;
}) => Column;

export const predefinedColumns: Record<string, DefaultColumnValue> = {
  date: ({ sortable = false, field = 'date', hide = false, headerName = locales.table.column.date }) => ({
    ...defaultColDef,
    field,
    headerName,
    flex: 1,
    minWidth: 120,
    valueFormatter: formatter.dateFormatter,
    sortable,
    hide
  }),
  orderDate: ({ sortable = true, field = 'date', hide = false, headerName = locales.table.column.orderDate }) => ({
    ...defaultColDef,
    field,
    headerName,
    flex: 1,
    minWidth: 120,
    valueFormatter: formatter.dateFormatter,
    sortable,
    hide
  }),
  status: ({ sortable = false }) => ({
    ...defaultColDef,
    field: 'status',
    headerName: locales.table.column.status,
    minWidth: 120,
    flex: 1,
    renderCell: statusRenderer,
    sortable
  }),
  cost: ({ sortable = false, withInfoIcon = false }) => ({
    ...defaultColDef,
    field: 'cost',
    renderHeader: withInfoIcon ? CostColumnHeader : CostColumnHeaderWithInfo,
    flex: 1,
    renderCell: withInfoIcon ? renderCost : formatter.amountFormatter,
    minWidth: 90,
    sortable
  })
};
